import { Box, IconButton, Typography, styled } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

import { FORTA_BLUE, FORTA_ERROR, FORTA_SUCCESS } from '../../../../utils/colors';

const listItemStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  py: 1,
};

interface SessionGradingSwitchProps {
  value: boolean | null;
  isEditable: boolean;
  datatestId?: string;
  disabled: boolean;
  label: string;
  onChange: (value: boolean) => void;
}

interface GradingSwitchProps {
  value: boolean | null;
  isEditable: boolean;
  disabled: boolean;
  onChange: (value: boolean) => void;
  datatestId?: string;
}

const StyledIconButton = styled(IconButton)(() => ({
  padding: 0,
}));

const GradingSwitch = (props: GradingSwitchProps) => {
  const { value, isEditable, onChange, datatestId, disabled } = props;

  return (
    <>
      {isEditable ? (
        <>
          <StyledIconButton
            disableRipple
            sx={{ mr: 0.5 }}
            disabled={disabled}
            onClick={() => onChange(false)}
          >
            {value === null || value === true ? (
              <CancelOutlinedIcon
                data-testid={`${datatestId}_no`}
                sx={{ color: FORTA_BLUE.light1 }}
              />
            ) : (
              <CancelIcon sx={{ color: FORTA_ERROR }} />
            )}
          </StyledIconButton>
          <StyledIconButton disableRipple disabled={disabled} onClick={() => onChange(true)}>
            {value === null || value === false ? (
              <CheckCircleOutlinedIcon
                data-testid={`${datatestId}_yes`}
                sx={{ color: FORTA_BLUE.light1 }}
              />
            ) : (
              <CheckCircleIcon sx={{ color: FORTA_SUCCESS }} />
            )}
          </StyledIconButton>
        </>
      ) : (
        <>
          {value ? (
            <CheckCircleIcon sx={{ color: FORTA_SUCCESS }} />
          ) : (
            <CancelIcon sx={{ color: FORTA_ERROR }} />
          )}
        </>
      )}
    </>
  );
};

function SessionGradingSwitch({
  value,
  label,
  datatestId,
  isEditable,
  disabled,
  onChange,
}: SessionGradingSwitchProps) {
  return (
    <Box sx={listItemStyle}>
      <GradingSwitch
        datatestId={datatestId}
        value={value}
        disabled={disabled}
        isEditable={isEditable}
        onChange={onChange}
      />
      <Typography ml={1} lineHeight={1.2}>
        {label}
      </Typography>
    </Box>
  );
}

export default SessionGradingSwitch;
